import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const DepartmentContext = createContext();

export function DepartmentProvider({ children }) {
  const [departments, setDepartments] = useState([]);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchDepartments() {
      setLoading(true);
      try {
        const res = await api.getDepartments();
        setDepartments(res.data);
        if (res.data.length > 0) {
          setSelectedDepartmentId(res.data[0].id);
        }
      } catch (error) {
        console.error('Error loading departments:', error);
      } finally {
        setLoading(false);
      }
    }
    fetchDepartments();
  }, []);

  return (
    <DepartmentContext.Provider value={{ 
      departments, 
      selectedDepartmentId, 
      setSelectedDepartmentId,
      loading
    }}>
      {children}
    </DepartmentContext.Provider>
  );
}

export function useDepartment() {
  return useContext(DepartmentContext);
} 